import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { CALL_OFF_SOURCE_LABEL_ENTRIES } from "../utils/callIns";
import type { ChangesSource } from "../utils/models";

// Shared by the Call-Ins report and the Last Call-Ins grid, which used to keep their own copies.
// SupportLine is still mapped because old rows have it.
// useCallback because callers put this in useMemo deps.
export const useCallOffSourceLabel = () => {
	const { t } = useTranslation();
	return useCallback(
		(source: ChangesSource | undefined): string => {
			const entry = CALL_OFF_SOURCE_LABEL_ENTRIES.find((e) => e.source === source);
			return entry ? t(entry.translationKey) : (source ?? "");
		},
		[t],
	);
};
